import { isSamePage } from '@/utils/middleware.js'
import { isValidRouteParamNumericId } from '@/utils/navigation.js'

export default defineNuxtRouteMiddleware((to, from) => {
  if (isSamePage(to, from) || to.meta?.skipMiddleware) {
    return
  }

  const config = useRuntimeConfig()

  if (config.public.playgroundEnabled && to.path === '/') {
    // use `external` to force reload
    return navigateTo('922', { external: true })
  }

  if (to.params.provetId) {
    // Check if the provetId is made up of digits
    const isValidProvetId = isValidRouteParamNumericId(to, 'provetId')
    if (!isValidProvetId) {
      throw createError({ statusCode: 404, statusMessage: 'Page Not Found' })
    }
  }
})
